// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__290rf","title":"Info_title__29G56","links":"Info_links__3RQ7Y","link":"Info_link__caQKT","logo":"Info_logo__6XuHW"};